function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function get(target, property, receiver) {
            var base = _super_prop_base(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver || target);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _get_prototype_of(object);
        if (object === null) break;
    }
    return object;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { AdBreakSource, AdBreakUpdateMergeStrategy, SsaiStitcherType } from '../../../addons/adverts/common';
import { PlaybackType } from '../../../core/player/playout-data';
import { TelemetryNotificationKey } from '../../../core/telemetry/telemetry-session';
import { sdkLogger } from '../../../logger';
import { checkIsManifestLinearType, checkIsManifestVodType } from '../../../utils/playback-type';
import { MediaTailorErrorCodes, MediaTailorRequestManager } from './media-tailor-request-manager';
import { BaseSsaiAdBreaksProvider } from './base-ssai-ad-breaks-provider';
import { MediaTailorAdBreaksPositionAdapter } from './media-tailor-ad-breaks-position-adapter';
import { JsonAdBreaksAdapter } from './ad-break-adapters/json/json-ad-breaks-adapter';
import { InternalSessionState } from '../../../core/session-controller/internal-session-state';
import { SimpleTimer } from '../../../utils/simple-timer';
var TRACKING_FALLBACK_WAIT_TIME_MS = 5000;
var FALLBACK_TRACKING_FETCH_STATES = [
    InternalSessionState.Paused,
    InternalSessionState.Playing
];
export var LegacyMediaTailorAdBreaksProvider = /*#__PURE__*/ function(BaseSsaiAdBreaksProvider) {
    "use strict";
    _inherits(LegacyMediaTailorAdBreaksProvider, BaseSsaiAdBreaksProvider);
    function LegacyMediaTailorAdBreaksProvider(pauseAdDispatcher, companionAdDispatcher, playbackType) {
        _class_call_check(this, LegacyMediaTailorAdBreaksProvider);
        var _this;
        var _this1;
        _this = _call_super(this, LegacyMediaTailorAdBreaksProvider), _this1 = _this, _define_property(_this, "pauseAdDispatcher", void 0), _define_property(_this, "companionAdDispatcher", void 0), _define_property(_this, "playbackType", void 0), _define_property(_this, "ssaiStitcherType", void 0), _define_property(_this, "mediaTailorRequestManager", void 0), _define_property(_this, "logger", void 0), _define_property(_this, "_hasAdBreaks", void 0), _define_property(_this, "adAdapter", void 0), _define_property(_this, "cachedAdBreaks", void 0), _define_property(_this, "shouldPreserveAdBreakData", void 0), _define_property(_this, "trackingCallErrored", void 0), _define_property(_this, "paginationEnabled", void 0), _define_property(_this, "trackingTimer", void 0), _define_property(_this, "getAdvertsViaTrackingURL", void 0), _this.pauseAdDispatcher = pauseAdDispatcher, _this.companionAdDispatcher = companionAdDispatcher, _this.playbackType = playbackType, _this.ssaiStitcherType = SsaiStitcherType.MediaTailor, _this.mediaTailorRequestManager = null, _this.logger = sdkLogger.withContext('MTBreaksProvider'), _this._hasAdBreaks = false, _this.cachedAdBreaks = new Map(), _this.shouldPreserveAdBreakData = false, _this.trackingCallErrored = false, _this.paginationEnabled = false, _this.trackingTimer = new SimpleTimer(), _this.getAdvertsViaTrackingURL = /*#__PURE__*/ _async_to_generator(function() {
            var mediaTailorTrackingResponse, e, warning, adBreakData, adBreaks;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this1.cancelTrackingFallbackTimer();
                        if (checkIsManifestVodType(_this1.playoutData.type) && (_this1.hasAdBreaks || _this1.trackingCallErrored)) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        // setting hasAdBreaks before the call caters for potential re-entry calls
                        _this1.hasAdBreaks = true;
                        _this1.telemetryUpdateObservable.notifyObservers({
                            key: TelemetryNotificationKey.trackingUrlRequestStart,
                            value: new Date().getTime()
                        });
                        return [
                            4,
                            _this1.mediaTailorRequestManager.requestDataUpdate()
                        ];
                    case 2:
                        mediaTailorTrackingResponse = _state.sent();
                        _this1.telemetryUpdateObservable.notifyObservers({
                            key: TelemetryNotificationKey.trackingUrlResponseEnd,
                            value: new Date().getTime()
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        warning = e;
                        if (warning.code !== MediaTailorErrorCodes.INTERVAL_EXCEEDED && warning.code !== MediaTailorErrorCodes.DESTROYED) {
                            _this1.logger.error(warning);
                            _this1.errorObservable.notifyObservers(warning);
                        }
                        _this1.hasAdBreaks = false;
                        _this1.trackingCallErrored = true;
                        return [
                            2
                        ];
                    case 4:
                        adBreakData = _this1.adAdapter.adapt(mediaTailorTrackingResponse, false);
                        adBreaks = _this1.shouldPreserveAdBreakData ? _this1.getCachedAdverts(adBreakData) : adBreakData.adBreaks;
                        if (!checkIsManifestVodType(_this1.playoutData.type)) {
                            _this1.startTrackingFallbackTimer();
                        }
                        if (adBreakData.nonLinearAds.length && adBreakData.nonLinearAds[adBreakData.nonLinearAds.length - 1].variants.length && 'adId' in adBreakData.nonLinearAds[adBreakData.nonLinearAds.length - 1].variants[0] && _this1.playbackType === PlaybackType.SingleLiveEvent) {
                            _this1.companionAdDispatcher.addAdEventsFromAdData(adBreakData.nonLinearAds);
                        } else {
                            _this1.pauseAdDispatcher.addAdEventsFromAdData(adBreakData.nonLinearAds);
                        }
                        _this1.notifyAdBreakDataReceived({
                            adBreaks: adBreaks,
                            source: _this1.paginationEnabled ? AdBreakSource.Paginated : AdBreakSource.Unpaginated,
                            mergeStrategy: _this1.paginationEnabled ? AdBreakUpdateMergeStrategy.Merge : AdBreakUpdateMergeStrategy.Overwrite
                        });
                        return [
                            2
                        ];
                }
            });
        });
        var adBreakStartAdjustment = MediaTailorAdBreaksPositionAdapter.getAdBreakStartAdjustment();
        _this.logger.verbose("Setting ad break start adjustment to ".concat(adBreakStartAdjustment));
        var adBreakEndAdjustment = MediaTailorAdBreaksPositionAdapter.getAdBreakEndAdjustment();
        _this.logger.verbose("Setting ad break end adjustment to ".concat(adBreakEndAdjustment));
        _this.adAdapter = new JsonAdBreaksAdapter(SsaiStitcherType.MediaTailor, adBreakEndAdjustment, adBreakStartAdjustment);
        return _this;
    }
    _create_class(LegacyMediaTailorAdBreaksProvider, [
        {
            key: "hasAdBreaks",
            get: function get() {
                return this._hasAdBreaks;
            },
            set: function set(value) {
                this._hasAdBreaks = value;
            }
        },
        {
            key: "startTrackingFallbackTimer",
            value: function startTrackingFallbackTimer() {
                var _this = this;
                this.trackingTimer.start({
                    timeMs: TRACKING_FALLBACK_WAIT_TIME_MS,
                    callback: function() {
                        _this.logger.warn('Executing fallback tracking request');
                        _this.getAdvertsViaTrackingURL();
                    }
                });
            }
        },
        {
            key: "cancelTrackingFallbackTimer",
            value: function cancelTrackingFallbackTimer() {
                this.trackingTimer.stop();
            }
        },
        {
            key: "init",
            value: function init(playoutData, requestManagerOptions) {
                this.playoutData = playoutData;
                this.paginationEnabled = Boolean(checkIsManifestLinearType(playoutData.type) && requestManagerOptions.paginationEnabled);
                this.mediaTailorRequestManager = new MediaTailorRequestManager(_object_spread_props(_object_spread({}, requestManagerOptions), {
                    paginationEnabled: checkIsManifestLinearType(playoutData.type) ? requestManagerOptions.paginationEnabled : false
                }));
                this.startTrackingFallbackTimer();
            }
        },
        {
            key: "onSessionStateChanged",
            value: /**
     * In the case of empty midrolls, there will not be any bulk metadata emitted, since there are no ads in the manifest
     * Regardless, we should still try and get adverts once playback starts if we haven't already done so
     * @param state
     * @returns
     */ function onSessionStateChanged(state) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.mediaTailorRequestManager) {
                                    return [
                                        2
                                    ];
                                }
                                if (!FALLBACK_TRACKING_FETCH_STATES.includes(state) || _this.hasAdBreaks) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    _this.getAdvertsViaTrackingURL()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onParsedManifest",
            value: function onParsedManifest() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.mediaTailorRequestManager) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    _this.getAdvertsViaTrackingURL()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "notifyAdBreaksNowAvailable",
            value: function notifyAdBreaksNowAvailable() {
                if (!this.mediaTailorRequestManager) {
                    return;
                }
                this.getAdvertsViaTrackingURL();
            }
        },
        {
            key: "preserveAdBreakData",
            value: function preserveAdBreakData(value) {
                this.shouldPreserveAdBreakData = value;
            }
        },
        {
            key: "disable",
            value: function disable() {
                var _this_mediaTailorRequestManager;
                this.cancelTrackingFallbackTimer();
                (_this_mediaTailorRequestManager = this.mediaTailorRequestManager) === null || _this_mediaTailorRequestManager === void 0 ? void 0 : _this_mediaTailorRequestManager.destroy();
                this.mediaTailorRequestManager = null;
                _get(_get_prototype_of(LegacyMediaTailorAdBreaksProvider.prototype), "disable", this).call(this);
            }
        },
        {
            key: "getCachedAdverts",
            value: function getCachedAdverts(adBreakData) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = adBreakData.adBreaks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var adBreak = _step.value;
                        this.cachedAdBreaks.set(adBreak.id, adBreak);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return _to_consumable_array(this.cachedAdBreaks.values());
            }
        }
    ]);
    return LegacyMediaTailorAdBreaksProvider;
}(BaseSsaiAdBreaksProvider);

//# sourceMappingURL=legacy-media-tailor-ad-breaks-provider.js.map